import axios from 'axios'
import { API_URL } from 'common/constants/env'
import api from 'common/infra/api'
import { IMigrationCompleteResponse, IMigrationService } from './types'

const migrationService: IMigrationService = {
  getMigrationFlowByEmail: async email => {
    const encodedEmail = encodeURIComponent(email)
    const url = `${API_URL}/users/migration?realm=B2B&email=${encodedEmail}`
    return axios.get(url)
  },
  completeMigration: async () => {
    const url = `${API_URL}/users/migration/completed`
    return api.post<IMigrationCompleteResponse>(url)
  },
}

export default migrationService
